<script lang="ts" setup>
  const router = useRouter()
</script>

<template>
  <div class="c-order-now-banner">
    <span class="header-4">Not what you’re looking for?</span>
    <CButton
      dark-mode
      variant="primary"
      @click="router.push('/restaurants')"
      @keydown.enter="router.push('/restaurants')"
    >
      Find another Grill'd
    </CButton>
  </div>
</template>

<style lang="scss" scoped>
  .c-order-now-banner {
    display: flex;
    flex-direction: column;

    align-items: center;
    justify-content: center;
    gap: 32px;

    width: 100%;
    padding: 24px 16px;
    text-align: center;

    background-color: var(--color-base-green);

    span {
      color: var(--color-base-white);
    }

    @include screenMdAndUp {
      flex-direction: row;
    }
  }
</style>
